import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import request from '../utils/request';
import { RootState } from '../utils/store';
import { signOut } from './user';

export const requestGamePlans = createAsyncThunk(
  'renewal/requestGamePlans',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await request.get(`/api/renewal/game-plan`);
      return data;
    } catch (err) {
      let error = err as AxiosError;
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const requestConfirmOrderRenewal = createAsyncThunk(
  'renewal/requestConfirmOrderRenewal',
  async (params: object, { rejectWithValue }) => {
    try {
      const { data } = await request.post(`/api/v2/renewal`, params);
      return data;
    } catch (err) {
      let error = err as AxiosError;
      return rejectWithValue(error?.response?.data);
    }
  }
);

export interface CustomTax {
  taxName: string;
  taxValue: number;
}

export interface GamePlanData {
  isLastPurchase: boolean;
  isOnSale: boolean;
  id: string;
  name: string;
  price: number;
  salePrice: number;
  term: number;
  numLesson: number;
  shName: string;
  customTax: CustomTax[];
}

type GamePlanState = {
  buck: number;
  gamePlans: null | GamePlanData[];
  lessonPacks: null | GamePlanData[];
  tax: number;
  taxName: string;
  selectPackage: null | GamePlanData;
  loadingRenewal: boolean;
  paymentStatus:boolean;
};

const initialState: GamePlanState = {
  buck: 0,
  gamePlans: null,
  lessonPacks: null,
  tax: 0,
  taxName: '',
  selectPackage: null,
  loadingRenewal: false,
  paymentStatus:false,
};

export const renewalSlice = createSlice({
  name: 'password',
  initialState,
  reducers: {
    setSelectPackage: (state, action) => {
      state.selectPackage = action.payload;
    },
    setPaymentStatus: (state,action)=> {
      state.paymentStatus = action.payload;
    },
    resetRenewal: (state) => ({
      ...initialState,
      gamePlans: state.gamePlans,
      lessonPacks: state.lessonPacks,
      tax: state.tax,
      buck: state.buck,
      taxName: state.taxName,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(requestGamePlans.pending, (state, action) => {
      state.loadingRenewal = true;
    });
    builder.addCase(requestGamePlans.fulfilled, (state, action) => {
      state.gamePlans = action.payload.data.gamePlans;
      state.lessonPacks = action.payload.data.lessonPacks;
      state.buck = action.payload.data.buck;
      state.tax = action.payload.data.tax;
      state.taxName = action.payload.data.taxName;
      state.loadingRenewal = false;
    });
    builder.addCase(signOut, () => ({ ...initialState }));
  },
});

export const { setSelectPackage, resetRenewal,setPaymentStatus } = renewalSlice.actions;

export const selectGamePlans = (state: RootState) => state.renewal.gamePlans;
export const selectedPackageRenewal = (state: RootState) =>
  state.renewal.selectPackage;
export const selectLessonPacks = (state: RootState) =>
  state.renewal.lessonPacks;
export const selectBucks = (state: RootState) => state.renewal.buck;
export const selectTaxRenewal = (state: RootState) => state.renewal.tax;
export const selectTaxName = (state: RootState) => state.renewal.taxName;
export const selectLoadingRenewal = (state: RootState) =>
  state.renewal.loadingRenewal;
  export const selectPaymentStatus= (state: RootState) => state.renewal.paymentStatus;

export default renewalSlice.reducer;
